import { useId as t } from "react";
const s = ({ id: e } = {}, d = "") => {
  const o = t();
  return e || `${d}${o}`;
};
export {
  s as useIdIfNeeded
};
